import { badnessColor } from '../../../constants/scoreScale';
import { clamp } from './forecast';

export function vcRatio(flow, capacity) {
  const safeCapacity = Number(capacity);
  return safeCapacity > 0 ? Number(flow || 0) / safeCapacity : 0;
}

/** V/C 0 → workbook green, V/C ≥ 1 (saturated) → workbook red. */
export function vcColor(value) {
  const ratio = clamp(Number(value || 0), 0, 1);
  return badnessColor(ratio);
}

export function vcLabel(value) {
  if (value >= 1) return 'Critico';
  if (value >= 0.85) return 'Prossimo alla saturazione';
  if (value >= 0.65) return 'Intermedio';
  return 'Regolare';
}

export function roadWeight(road, ratio) {
  const base = Number(road?.frc) <= 1 ? 5.4 : Number(road?.frc) <= 3 ? 4.2 : 3;
  return base + clamp(ratio, 0, 1) * 2.4;
}
